import { render, staticRenderFns } from "./WPDatetimepicker.vue?vue&type=template&id=1f1b2d9d"
import script from "./WPDatetimepicker.vue?vue&type=script&lang=ts"
export * from "./WPDatetimepicker.vue?vue&type=script&lang=ts"
import style0 from "./WPDatetimepicker.vue?vue&type=style&index=0&id=1f1b2d9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports